import { format } from "date-fns";
import React, { useContext } from "react";
import { Container, Row, Col, Card, Table, Badge } from "react-bootstrap";
import { ToWords } from "to-words";
import { UserContext } from "../../../Context/UserContextAPI";
import { useGetSoftwareInformationById } from "../../../API/softwareInformation.api";
import { useGetAllSubscriptionPayment } from "../../../API/subscriptionPayment.api";
import calculateDueMonths from "../../../utils/calculateDueMonths";
import { generateSubscriptionInvoiceNumber } from "../../../utils/helper";

const firstColor = "#2d328c";
const secondColor = "#417dbe";

const SubscriptionInvoicePage = ({
	isMoneyReciept = false,
	moneyRecieptData,
}) => {
	const { data: softwareInformation } = useGetSoftwareInformationById(1);

	const { data: subscriptionPayment } = useGetAllSubscriptionPayment();

	const dueMonths = calculateDueMonths(
		subscriptionPayment,
		softwareInformation?.due_month_count_from,
	);

	const invoiceNumber = generateSubscriptionInvoiceNumber(
		softwareInformation?.invoice_pattern,
	);

	const toWords = new ToWords({
		locale: "en-IN",
		converterOptions: {
			currency: true,
			currencyOptions: {
				name: "Taka",
				plural: "Taka",
				symbol: "৳",
				fractionalUnit: {
					name: "Paisa",
					plural: "Paisa",
					symbol: "",
				},
			},
		},
	});

	const totalInWords = toWords.convert(
		isMoneyReciept
			? moneyRecieptData?.amount
			: (softwareInformation?.software_price || 0) * dueMonths.length,
	);

	return (
		<div className="color-print">
			<div className="main-content px-5">
				<div className="d-flex justify-content-between">
					<img src="dhakaApps-logo.png" alt="dhaka" />
					<img src="dal-logo.png" alt="dhaka" />
				</div>
				<div className="">
					<div className="p-4">
						{/* Header */}
						<Row className="mb-4">
							<Col md={6}>
								<h1 className="fw-bold fs-1" style={{ color: firstColor }}>
									{isMoneyReciept ? "MONEY RECIEPT" : "INVOICE"}
								</h1>
								<p className=" mb-0 fs-5" style={{ color: secondColor }}>
									{isMoneyReciept
										? moneyRecieptData?.marchent_invoice_number
										: invoiceNumber}
								</p>
							</Col>
							<Col md={6} className="text-md-end">
								<div>
									<p
										className="mb-0 fs-4 text-uppercase"
										style={{ color: secondColor }}
									>
										Date
									</p>
									<p className="mb-0 fs-4">
										{isMoneyReciept
											? format(
													new Date(moneyRecieptData?.payment_date),
													"MMMM dd, yyyy",
												)
											: format(new Date(), "MMMM dd, yyyy")}
									</p>
								</div>
							</Col>
						</Row>

						{/* Billing Information */}
						<Row className="mb-4">
							<Col md={6}>
								<h5 className="fs-5" style={{ color: secondColor }}>
									PREPARED FOR
								</h5>
								<h6 className="fw-bold fs-5 text-dark">
									{softwareInformation?.customer_name}
								</h6>
								<p className="mb-0 fs-5 text-muted">
									{softwareInformation?.customer_address}
								</p>
							</Col>
							<Col md={6} className="text-md-end">
								<h5 className="fs-5" style={{ color: secondColor }}>
									REFERENCE
								</h5>
								<h6 className="fw-bold fs-5 text-dark">
									{softwareInformation?.customer_reference}
								</h6>
							</Col>
						</Row>

						{/* Services */}
						<Table bordered className="mb-4 invoice-table">
							<thead className="bg-light">
								<tr>
									<th>SRL.</th>
									<th>SERVICES</th>
									<th className="text-end">PRICE (BDT)</th>
								</tr>
							</thead>
							<tbody>
								{(isMoneyReciept
									? [moneyRecieptData?.payment_month]
									: dueMonths
								).map((month, i) => (
									<tr key={month?.id || i}>
										<td>{i + 1}</td>
										<td>
											Software Subscription Charge -{" "}
											{format(new Date(month), "MMMM yyyy")}
										</td>
										<td className="text-end">
											৳ {softwareInformation?.software_price}
										</td>
									</tr>
								))}
								<tr className="fw-bold">
									<td colSpan={2} className="text-end">
										Total (Incl. VAT & Tax)
									</td>
									<td className="text-end">
										৳{" "}
										{isMoneyReciept
											? moneyRecieptData?.amount
											: softwareInformation?.software_price * dueMonths.length}
									</td>
								</tr>
								{isMoneyReciept && (
									<tr className="fw-bold">
										<td colSpan={2} className="text-end">
											Paid Amount
										</td>
										<td className="text-end">৳ {moneyRecieptData?.amount}</td>
									</tr>
								)}
								<tr>
									<td colSpan={3} className="">
										In Words: {totalInWords}
									</td>
								</tr>
							</tbody>
						</Table>

						{/* Footer */}
						<div className="">
							<p className="mb-1 fw-bold fs-4">Thank you for the business!</p>
							<div className="mt-4 pt-2">
								<p className="mb-0 fs-4">Accounts</p>
								<p className=" text-22">
									{softwareInformation?.owner_company_name}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="text-center">
				<p className=" mb-2">
					This is System genereted{" "}
					{isMoneyReciept ? "Money Reciept" : "Invoice"}, No signature required.
				</p>
			</div>
			<div
				className="text-center text-white w-100"
				style={{
					backgroundColor: "#447cbf",
				}}
			>
				<p className="text-uppercase fs-4 mb-0 text-white">
					{softwareInformation?.owner_company_name}
				</p>
				<p className="fs-5 mb-0 text-white">
					{softwareInformation?.owner_company_address}
				</p>
				<p className="fs-5 mb-0 text-white">
					{softwareInformation?.owner_company_info}
				</p>
			</div>
		</div>
	);
};

export default SubscriptionInvoicePage;
